module.exports = __webpack_public_path__ + "img/9788932910505.5ebe1988.jpg";